export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de procesos"])},
          "containers_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contenedores"])},
          "export_invoices_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Facturas"])},
          "show_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ver"])},
          "new_export_invoice_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nueva factura"])},
          "total_number_containers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contenedores"])},
          "total_number_containers_paid": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contenedores pagados"])},
          "total_number_export_invoices": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Facturas"])},
          "total_number_export_invoices_paid": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Facturas pagadas"])},
          "total_amount": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Monto total"])},
          "num_export_invoices": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["# Facturas"])},
          "export_invoices_paid": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pagadas"])},
          "paid": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pagado"])},
          "download_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Descargar reporte"])}
        }
      },
      "en": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Go back to list of process"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Containers"])},
          "show_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Show"])},
          "total_number_containers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Containers"])}
        }
      }
    }
  })
}